// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__2YulO","label":"Completed_label__2dK0Q"};